'use strict';

import React, { Component } from 'react'

import DeleteModal from '@Modal/DeleteModal'

import TicketTrackingModal from '@Modal/TicketTrackingModal'

import ProviderOrderModal           from '@Modal/ProviderOrderModal'
import ProviderTransactionModal     from '@Modal/ProviderTransactionModal'
import ExportedProvidersOrdersModal from '@Modal/ExportedProvidersOrdersModal'
import ProviderOrderMassActionModal from '@Modal/ProviderOrderMassActionModal'
import PartnerRenewalModal          from '@Modal/PartnerRenewalModal'
import OrderCommentModal            from '@Modal/OrderCommentModal'

import ShippingDeliveryModal from '@Modal/ShippingDeliveryModal'
import CustomQuoteItemModal  from '@Modal/CustomQuoteItemModal'
import ShippingModal         from '@Modal/ShippingModal'
import CancelProductModal    from '@Modal/CancelProductModal'

import GlobalSearchResults from '@/GlobalSearchResults'
import PageTitle           from '@/PageTitle'

import Header from '@Navigation/UserHeader'

let app = window.app;

export default class BackOffice extends Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		app.router_history = this.props.history;
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.handleSessionChange();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session?.permissions) return;

		component.setState(
		{
			permissions: app.state.session.permissions
		});
	}

	documentClick = () =>
	{
		app.emit('documentClick');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var output =
		(
			<div className="page-wrapper" onClick={ component.documentClick }>

				<Header history={ props.history }
					permissions={ state.permissions }
				/>

				{ state.head_warning }

				<div className="page">

					<div className={ 'page-body' +
						(props.show_scroll ? ' u-scroll-y' : '') }>

						<GlobalSearchResults />

						<PageTitle history={ props.history }
							title={ props.page_title }
							pathname={ props.page_title_pathname }
							hide_title={ props.hide_title }
						/>

						{ props.children }

					</div>

					<DeleteModal />

					<TicketTrackingModal />

					<ProviderOrderModal />
					<ProviderTransactionModal />
					<ExportedProvidersOrdersModal />
					<ProviderOrderMassActionModal />

					<ShippingModal />
					<ShippingDeliveryModal />
					<CancelProductModal />

					<CustomQuoteItemModal />

					<PartnerRenewalModal />

					<OrderCommentModal />

				</div>

			</div>
		);

		return output;
	}
}
